import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Optional,
  Output,
  Self,
  ViewChild,
} from '@angular/core';
import {ControlValueAccessor, NgControl} from '@angular/forms';
import { __values } from 'tslib';

@Component({
  standalone: false,
  selector: 'app-b3-textarea',
  templateUrl: './b3-textarea.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class B3TextareaComponent implements AfterViewInit, ControlValueAccessor {

  public _inputValue?: string;
  public  hasNgCtrol: boolean = false;
  public focused: boolean = false;
  public touched: boolean = false;
  public isValid: boolean = false;

  @ViewChild('input', {static: true})
  public inputViewChild?: ElementRef;

  @Input()
  public label: string = '';

  @Input()
  public inputId: string = '';

  @Input()
  public type: string = 'text';

  @Input()
  public placeholder: string = '';

  @Input()
  public disabled: boolean = false;

  @Input()
  public helpMsg: string = '';

  @Input()
  public successMsg: string = '';

  @Input()
  public errorMsg: string = '';

  @Input()
  public small: boolean = false;

  @Input()
  public height: number = 100;

  @Input() 
  public validate: boolean = false;

  @Input() 
  public name: string = '';

  @Input() 
  public autocomplete: string | 'on' | 'off' = 'off';

  @Input() 
  public maxlength: number = 0;

  @Input() 
  public size: number = 0;

  @Output() 
  public valueChange: EventEmitter<any> = new EventEmitter<any>();

  @Output() 
  public focusChange: EventEmitter<any> = new EventEmitter<any>();

  @Output() 
  public keyUp: EventEmitter<any> = new EventEmitter<any>();

  @Output() 
  public keyDown: EventEmitter<any> = new EventEmitter<any>();

  @Output() 
  public blurred: EventEmitter<any> = new EventEmitter<any>();

  onModelChange = (value : any) => {};
  onModelTouched?: () => {};

  constructor(
    private cd: ChangeDetectorRef,
    @Self() @Optional()
    public ngControl: NgControl,
    ) {
    if (this.ngControl) {
      this.hasNgCtrol = true;
      this.ngControl.valueAccessor = this;
    } 
  }

  ngAfterViewInit(): void {
    if (!this.inputId) {
      throw new Error(`b3Textarea needs \'idInput\'`);
    }
    if (!this.maxlength || this.maxlength <= 0) {
      throw new Error(`b3Textarea needs \'maxlength\'`);
    }
  }

  handleFocus(event: Event): void {
    this.focused = true;
    this.focusChange.emit(event);
  }

  handleBlur(event: Event): void {
    this.focused = false;
    if(this.onModelTouched != null){
      this.onModelTouched();
    }
    this.blurred.emit(event);
    this.checkIfIsValid();
  }

  checkIfIsValid(): void {
    this.touched = true;
    const hasAnyValidator = this.ngControl?.control?.validator;
    if (this.validate && hasAnyValidator) {
      let control = this.ngControl?.control;
      if(control !== undefined && control != null){
        this.isValid = control.valid;
      }else{
        this.isValid = false;
      }
    }
  }

  updateModel(event : any): void {
    this._inputValue = event;
    this.onModelChange(this._inputValue);
    this.valueChange.emit({
      originalEvent: event,
      value: this._inputValue,
    });
  }

  writeValue(value: any): void {
    if (!value) value = '';
    this._inputValue = value;
    if(this.inputViewChild != null){
      this.inputViewChild.nativeElement.value = this._inputValue;
    }
    this.cd.markForCheck();
  }

  registerOnChange(fn: (value : any) => {}): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
    this.cd.markForCheck();
  }

  handleKeyUp(event : any): void {
    this.keyUp.emit(this._inputValue);
  }

  handleInput(event: any) {
    this.updateModel(event.target.value);
  }
}